import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { BOOKING } from "@/shared/resource/apis/endpoints";
import { BOOKING_INFORMATION } from "@/shared/resource/constants";
import { dateTime } from "@/shared/utills/date";
export const useBookingStore = defineStore("booking", {
  state: () => ({
    entities: [],
    totalEntities: 0,
    bookingInformation: [...BOOKING_INFORMATION],
  }),

  actions: {
    async fetch({ page = 1, limit = 10, filters = {} }) {
      this.clearEntities();
      const response = await api.get(BOOKING.GET, {
        params: { page_no: page, limit, ...filters },
      });
      const data = response?.data?.data || [];

      const formattedEntities = data.map((booking) => ({
        id: booking.booking_id,
        createdAt: dateTime.formatDateTime(booking.created_at),
        phoneNumber: booking.primary_passenger_contact,
        fromTo: `${booking.source}-${booking.destination}`,
        passengers: booking.total_passengers,
        totalPrice: booking.total_fare,
        bookingDevice: booking.web_booking,
        bookingStatus: booking.booking_status,
      }));

      this.setInformation(response.data);
      this.setEntities(formattedEntities, response?.data?.total_entries || 0);
      return formattedEntities;
    },

    async getBookingById(id) {
      const response = await api.get(BOOKING.GET_BY_ID(id));
      return response.data || [];
    },

    setEntities(entities, totalEntities) {
      this.entities = entities;
      this.totalEntities = totalEntities;
    },

    clearEntities() {
      this.entities = [];
      this.totalEntities = 0;
    },

    setInformation(stats) {
      const {
        total_booking = 0,
        total_revenue = 0,
        cancelledBooking = 0,
      } = stats;
      this.bookingInformation[0].count = total_booking;
      this.bookingInformation[1].count = total_revenue;
      this.bookingInformation[2].count = cancelledBooking;
    },
  },

  getters: {
    getEntities: (state) => state.entities,
    getTotalEntities: (state) => state.totalEntities,
    getInformation: (state) => state.bookingInformation,
  },
});
